import { useInvitationToken } from "../hooks/OrgInvite/useInvitationToken";
import { TokenInvitationContext } from "./TokenInvitationContext";

interface TokenInvitationProviderProps {
  children: React.ReactNode;
}

export function TokenInvitationProvider({
  children,
}: TokenInvitationProviderProps) {
  const { tokens, removeToken, clearTokens, respondToToken } =
    useInvitationToken();

  return (
    <TokenInvitationContext.Provider
      value={{
        tokens,
        removeToken,
        clearTokens,
        respondToToken,
      }}
    >
      {children}
    </TokenInvitationContext.Provider>
  );
}
